const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20frame%20showing%20a%20dramatic%20sci-fi%20scene%20with%20an%20astronaut%20floating%20in%20deep%20space%20with%20distant%20stars%2C%20golden%20sunlight%20hitting%20the%20helmet%20visor%2C%20epic%20composition%2C%20rich%20contrast%2C%20dark%20background&width=800&height=450&seq=media-thumb-01&orientation=landscape',
    title: '流浪地球 3：终极预告解析',
    duration: '4:32',
    views: '128万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20film%20scene%20with%20a%20detective%20standing%20in%20a%20rainy%20alley%20illuminated%20by%20a%20single%20streetlamp%2C%20noir%20cinematography%2C%20dramatic%20shadows%2C%20film%20grain%20texture%2C%20moody%20atmosphere&width=800&height=450&seq=media-thumb-02&orientation=landscape',
    title: '悬疑烧脑：2026 年最值得看的五部',
    duration: '6:15',
    views: '96万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20animated%20scene%20with%20vibrant%20colors%20showing%20a%20mythical%20Chinese%20dragon%20soaring%20through%20storm%20clouds%20with%20lightning%2C%20epic%20animation%20style%2C%20dramatic%20lighting%2C%20dynamic%20composition&width=800&height=450&seq=media-thumb-03&orientation=landscape',
    title: '国漫崛起：从大圣到哪吒的进化史',
    duration: '8:47',
    views: '203万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20film%20scene%20showing%20a%20classic%20Hong%20Kong%20street%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20vintage%20cinematic%20aesthetic%2C%20rich%20saturated%20colors%2C%20atmospheric&width=800&height=450&seq=media-thumb-04&orientation=landscape',
    title: '港片黄金时代：不可错过的经典重映',
    duration: '5:50',
    views: '87万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dreamlike%20cinematic%20scene%20with%20a%20couple%20silhouetted%20against%20a%20golden%20sunset%20on%20a%20quiet%20beach%2C%20soft%20focus%2C%20romantic%20film%20aesthetic%2C%20warm%20tones%2C%20gentle%20waves&width=800&height=450&seq=media-thumb-05&orientation=landscape',
    title: '七夕特辑：十部让人相信爱情的电影',
    duration: '7:22',
    views: '156万',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-play-circle-fill text-primary-400 text-xs"></i></span>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">精彩内容</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">精彩预告</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">精选热门电影推荐相关的预告解析、盘点与深度内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-foreground-50 text-lg"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-background-950/70 text-[10px] text-foreground-200 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-xs font-medium text-foreground-100 mb-1 line-clamp-2 group-hover:text-primary-400 transition-colors">{item.title}</h3>
                <span className="text-[10px] text-foreground-500">{item.views} 次播放</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}